import PropTypes from 'prop-types';
import React from 'react';
import dateformat from 'dateformat';
import { Link } from 'react-router-dom';
import { Col, Image } from 'react-bootstrap'; 

import LockIcon from 'src/legacy/components/LockIcon';
import { FileService } from 'src/utils/file.service';
import PlayButton from '../../../components/PlayButton';
import DOMPurify from 'dompurify';
import _ from 'lodash';
import cx from 'classnames';
import styles from './AssetView.module.scss'

import { localizedStrings } from 'src/localization';
import Text from 'src/components/text';

const AssetDefaultIcon = "/images/assets/default_asset.jpg"
class AssetView extends React.Component {
  static contextTypes = {
    recordAssetClicked: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      filter: 'all',
      showDetailView: false,
      showAddToCollection: false
    }

    this.handleAssetClick = this.handleAssetClick.bind(this);
    this.onAssetDetailViewClicked = this.onAssetDetailViewClicked.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedSearch = localizedStrings.pages.search;
    this.localizedKeywords = localizedStrings.keywords;
  }

  componentDidMount() {

  }

  onAssetDetailViewClicked(e) {
    e.preventDefault();
    e.stopPropagation();

    if (this.props.onSelection) {
      this.props.onSelection();
    }
  }

  handleAssetClick(e) {
    this.context.recordAssetClicked({
      asset: this.props.asset.id,
      index: this.props.index
    });
     
    this.props.recordSearchClick(_.get(this.props, 'asset.id'), "asset");
  }

  render() {
    const asset = this.props.asset;
    const streamsCount = _.get(_.uniq(this.props.asset.streams), 'length', 0);
    var link = "";
    if(this.props.query){
      link = `/assets/${asset.id}?source=search?query=${this.props.query}`
    }else{
      link = `/assets/${asset.id}`;
    }
    return (
      <div className={cx(styles.asset, { [styles.selected]: this.props.selected })}>
      {this.props.asset.settings && !this.props.asset.settings.share &&
        <LockIcon direction="left" className={cx(styles.lock)} />
      }
      <Link to={link} className={styles.assetLink} onClick={this.handleAssetClick}>
        <div className={styles.assetCardContainer}>
          <div className={styles.left}>
            <div className={styles.iconContainer}>
              {asset.metadata &&
                <PlayButton asset={asset} className={styles.playButton} size={60} />
              }
              <Image className={styles.icon} src={this.renderAssetIcon()} />
            </div>

          </div>
          <div className={styles.details}>
            <div className={styles.name}>
                <Text text={DOMPurify.sanitize(asset.name, { ALLOWED_TAGS: [] })} lines={1} />
            </div>
            <div className={styles.metadataWrapper}>
              <Col sm={12} className={cx(styles.assetMetrics, styles.paddingTop)}>
                {this.renderAssetSummary(asset)}
                {_.get(asset, "metadata.content_length") > 0 &&
                  <div className={styles.metrics}>
                    <span>{FileService.formatSize(_.get(asset, "metadata.content_length"))}</span>
                  </div>
                }
                <div className={styles.metrics}>
                  <span>{FileService.getFileType(asset.metadata)}</span>
                </div>
              </Col>
              <Col sm={12} className={cx(styles.date, styles.noPadding)}>
                <span> { this.localizedCommons.last_updated } {dateformat(asset.contentModifiedDate, 'dd mmm yyyy')}</span>
              </Col>
              <Col sm={12} className={cx(styles.accessLevel, { [styles.showHideButton]: this.props.selected })} onClick={this.onAssetDetailViewClicked}>
                <span>{this.props.selected ? this.localizedSearch.asset.asset_detail_view.actions.hide_details : this.localizedSearch.asset.asset_detail_view.actions.show_details }</span>
                <i className={cx('paperflite-dropdown', { [styles.downArrow]: this.props.selected })}></i>
              </Col>
            </div>
          </div>
        </div>
      </Link>
    </div>
    );
  }

  renderAssetIcon() {
    const asset = this.props.asset;
    var icon = AssetDefaultIcon;
    if (asset.icon) {
      icon = asset.icon.thumbnail;
    }

    return icon;
  }

  renderAssetSummary(asset) {
    if (asset.metadata.pages) {
      return (
        <div className={styles.metrics}>
          <span>{asset.metadata.pages} { this.localizedCommons.pages }</span>
        </div>
      );
    } else if (asset.metadata.video_duration) {
      return (
        <div className={styles.metrics}>
          <span>{this.formartVideoDuration(_.get(asset, "metadata.video_duration"))}</span>
        </div>
      );
    }

    return false;
  }

  formartVideoDuration(timeSpent) {
    let timeSpentValue = `${this.padNumber(timeSpent, 1)} Seconds`;

    if (timeSpent >= 60) {
      var minutes = Math.round(timeSpent / 60);
      timeSpentValue = `${this.padNumber(minutes, 1)} Minute${minutes == 1 ? '' : 's'}`;
    }

    return timeSpentValue;
  }

  padNumber(number = 0, pad) {
    number = Math.ceil(number);

    const length = pad - String(number).length + 1;
    let padding = '';
    if (length > 0) {
      padding = Array(pad - String(number).length + 1).join('0');
    }
    return padding + number;
  }
}

export default AssetView;